import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-confirm',
  templateUrl: './info-confirm.component.html',
  styleUrls: ['./info-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InfoConfirmComponent implements OnInit {

  @Input() message: string = '';
  @Input() acceptButtonText: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

}
